<template>
  <v-container>
    Imprint
  </v-container>
</template>

<script lang="ts">
import Component from 'vue-class-component'
import Vue from 'vue'

@Component
export default class Imprint extends Vue {
}
</script>

<style scoped>

</style>
